import React, { Component } from "react";
import copy from "copy-to-clipboard";
import ToggleSwitch from './ToggleSwitchs';
import settingIcon from '../../../images/settings.svg'
import editIcon from '../../../images/group_edit.svg'
import deactivateIcon from '../../../images/deactivate_user.svg'
import changeCredentialsIcon from '../../../images/change_credentials.svg'
import referralsIcon from '../../../images/referrals.svg'
import copyIcon from '../../../images/copy.svg'
import activateIcon from '../../../images/activate.svg'
import resendEmailIcon from '../../../images/resend_email.svg'

class Users_no_row extends Component {
    constructor(props) {
        super(props);
        this.menuRef = React.createRef()
        this.state = {
            URLText: '',
            copied: false,
            copy_tooltip: 'Copy Migration Link',
            changedCommSetting: false,
            copy_tooltip1: 'Copy Activation Link',
            copy_phone_tooltip1: 'Copy Phone Number'
        };
        this.Copytext = this.Copytext.bind(this);
        this.Copytext1 = this.Copytext1.bind(this);
        this.Copyphone = this.Copyphone.bind(this);
        this.tiercommissionFunc = this.tiercommissionFunc.bind(this);
        this.secondarycardFunc = this.secondarycardFunc.bind(this);
    }
    componentDidMount() {
        document.addEventListener("click", this.handleClickOutside, true);
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.handleClickOutside, true);
    }
    handleClickOutside = (event) => {
        if (
            this.menuRef.current &&
            !this.menuRef.current.contains(event.target) &&
            !event.target.closest('.user-action-toggle') &&
            !event.target.closest('.user-action-mobile-trigger') &&
            !event.target.closest('.user-action-menu')
        ) {
            if (this.props.show_settings !== null) {
                this.props.setActiveSetting(null);
            }
        }
    };

    handleMenuToggle = (event) => {
        event.stopPropagation();
        if (event.nativeEvent && event.nativeEvent.stopImmediatePropagation) {
            event.nativeEvent.stopImmediatePropagation();
        }
        const { userId, show_settings, setActiveSetting } = this.props;
        setActiveSetting(show_settings === userId ? null : userId);
    };

    closeMenu = () => {
        if (this.props.show_settings !== null) {
            this.props.setActiveSetting(null);
        }
    };

    handleActionClick = (handler) => (event) => {
        this.closeMenu();
        if (handler) {
            handler(event);
        }
    };

    Copytext = (e) => {
        copy(window.location.origin + "/" + e.target.getAttribute('data-text'));
        this.setState({ copy_tooltip: "Copied" });
        setTimeout(() => {
            this.setState({ copy_tooltip: "Copy Migration Link" });
        }, 600)
    }
    Copytext1 = (e) => {
        copy(window.location.origin + "/" + e.target.getAttribute('data-text'));
        this.setState({ copy_tooltip1: "Copied" });
        setTimeout(() => {
            this.setState({ copy_tooltip1: "Copy Activation Link" });
        }, 600)
    }
    Copyphone = (e) => {
        copy(e.target.getAttribute('data-text'));
        this.setState({ copy_phone_tooltip1: "Copied" });
        setTimeout(() => {
            this.setState({ copy_phone_tooltip1: "Copy Phone Number" });
        }, 600)
    }
    handleRowPagin = (e) => {
        this.props.userPagin(e);
    }
    tiercommissionFunc = (e) => {
        const checkLoader = e.target.parentElement.parentElement.children[0].classList.contains('report-loader') ? e.target.parentElement.parentElement.children[0] : null
        if (checkLoader) checkLoader.style.display = 'flex'
        this.props.TierCommission(e)
    }
    secondarycardFunc = (e) => {
        const checkLoader = e.target.parentElement.parentElement.children[0].classList.contains('report-loader') ? e.target.parentElement.parentElement.children[0] : null
        if (checkLoader) checkLoader.style.display = 'flex'
        this.props.SecondaryCard(e)
    }

    renderActionIcon(iconSrc) {
        return <img className="user-action-icon" src={iconSrc} alt="" aria-hidden="true" />;
    }

    renderActionItems() {
        const {
            userName, firstName, lastName, email, userStatus, userId,
            isMigrated, setupLink, phone, tierCommission_Setting, secondarycard,
            isEmailActivated, toggle_add_edit_popup, activate_deactivate, ClosePopUp,
            toggle_refferal_pop, resendActivationApi
        } = this.props;

        return (
            <>
                <div className="report-loader" style={{ display: 'none' }}></div>
                {userStatus == "Active" ?
                    <>
                        <i className="edit user-action-item" repid={userId} onClick={this.handleActionClick(toggle_add_edit_popup)} user_fullname={firstName + " " + lastName}>
                            {this.renderActionIcon(editIcon)}
                            <span className="user-action-label" user_fullname={firstName + " " + lastName} repid={userId}>Edit User</span>
                        </i>
                        <i className="deactivate user-action-item" onClick={this.handleActionClick(activate_deactivate)} status="Deactivate" numbering={userId}>
                            {this.renderActionIcon(deactivateIcon)}
                            <span className="user-action-label" status="Deactivate" numbering={userId}>Deactivate User</span>
                        </i>
                        <i className="change_credentials user-action-item" indexing={userId} onClick={this.handleActionClick(ClosePopUp)}>
                            {this.renderActionIcon(changeCredentialsIcon)}
                            <span className="user-action-label" indexing={userId}>Change Credentials</span>
                        </i>
                        <i className="referrals user-action-item" name_user={userName} onClick={this.handleActionClick(toggle_refferal_pop)} numbering={userId} user_fullname={firstName ? firstName + " " + lastName : userName}>
                            {this.renderActionIcon(referralsIcon)}
                            <span className="user-action-label" name_user={userName} numbering={userId} user_fullname={firstName + " " + lastName}>Referrals</span>
                        </i>
                        <i className="user-action-item user-action-checkbox">
                            <input type="checkbox" id={"TierCommission-" + userId} name="TierCommission" value={tierCommission_Setting} checked={tierCommission_Setting} onChange={this.tiercommissionFunc.bind(this)} numbering={userId} name_user={userName} email_user={email} />
                            <span className="user-action-label" numbering={userId}>Commission Tiers</span>
                        </i>
                        <i className="user-action-item user-action-checkbox">
                            <input type="checkbox" id={"SecondaryCard-" + userId} name="SecondaryCard" value={secondarycard} checked={secondarycard} onChange={this.secondarycardFunc.bind(this)} numbering={userId} name_user={userName} email_user={email} />
                            <span className="user-action-label" numbering={userId}>Display Secondary Cards</span>
                        </i>
                        {isMigrated == false && setupLink !== 'n/a' ?
                            <i className="copytext user-action-item" data-text={setupLink} onClick={this.handleActionClick(this.Copytext.bind(this))}>
                                {this.renderActionIcon(copyIcon)}
                                <span className="user-action-label" data-text={setupLink}>{this.state.copy_tooltip}</span>
                            </i>
                            : null}
                    </> :
                    isEmailActivated && userStatus !== "Profile Pending" ?
                        <i className="activate user-action-item" onClick={this.handleActionClick(activate_deactivate)} status="Activate" numbering={userId}>
                            {this.renderActionIcon(activateIcon)}
                            <span className="user-action-label" status="Activate" numbering={userId}>Activate User</span>
                        </i>
                        : userStatus === "Profile Pending" && userName.indexOf('rxh-user-') > -1 && setupLink !== 'n/a' ?
                            <i className="copytext user-action-item" data-text={setupLink} onClick={this.handleActionClick(this.Copytext.bind(this))}>
                                {this.renderActionIcon(copyIcon)}
                                <span className="user-action-label" data-text={setupLink}>{this.state.copy_tooltip}</span>
                            </i> : null
                }
                {!isEmailActivated && userStatus !== "Active" ?
                    <>
                        <i className="resend_email user-action-item" status="sent" numbering={userId} name_user={userName} onClick={this.handleActionClick(resendActivationApi)}>
                            {this.renderActionIcon(resendEmailIcon)}
                            <span className="user-action-label">Resend Verification</span>
                        </i>
                        {setupLink !== 'n/a' ?
                            <i className="copytext user-action-item" data-text={setupLink} onClick={this.handleActionClick(this.Copytext1.bind(this))}>
                                {this.renderActionIcon(copyIcon)}
                                <span className="user-action-label" data-text={setupLink}>{this.state.copy_tooltip1}</span>
                            </i> : null}
                        <i className="copytext user-action-item" data-text={phone} onClick={this.handleActionClick(this.Copyphone.bind(this))}>
                            {this.renderActionIcon(copyIcon)}
                            <span className="user-action-label" data-text={phone}>{this.state.copy_phone_tooltip1}</span>
                        </i>
                    </> : null}
            </>
        );
    }

    render() {
        const { userName, firstName, lastName, email, groupNumber, userStatus, userId, referral_Link_Request_Status, paymentStatus, mailStatus, show_settings, tabName } = this.props;
        const showSettings = show_settings === userId;
        return (
            <div className="table_row user_page user_data">
                {userName ?
                    (<div>
                        <div>{userName}</div>
                        <div>{firstName} {lastName}</div>
                        <div className="overflow-reset">{email} {mailStatus === 'Risky' ? <i className="tooltip risky-email"><strong className="icon">!</strong><span>This email was flagged as risky</span></i> : null} </div>
                        <div>{groupNumber}</div>
                        <div>{userStatus}</div>
                        <ToggleSwitch tabName={tabName} rowPagin={this.handleRowPagin} userstatus={userStatus} numbering={userId} payment={paymentStatus} username={userName} email={email} setStateOfParent={this.props.setStateOfParent} />
                        <div className={`user-table-actions ${showSettings ? 'is-open' : ''} ${referral_Link_Request_Status == "Requested" ? "requested_box" : ""}`} ref={this.menuRef}>
                            {!showSettings ?
                                <div className="mobile_menu_icon user-action-mobile-trigger" onClick={this.handleMenuToggle} role="button" aria-label="Open actions menu"></div>
                                : null}
                            <div className="user-action-toggle" onClick={this.handleMenuToggle} role="button" aria-label="Open actions menu">
                                <img src={settingIcon} alt="" />
                            </div>
                            {showSettings ?
                                <div className="user-action-menu">
                                    {this.renderActionItems()}
                                </div> : null}
                        </div>
                    </div>) : (
                        <div>
                            <div className="no_record_found">No Record Found</div>
                        </div>
                    )}
            </div>
        );
    }
}
export default Users_no_row;
